import l0 from "./locales/bg.json" with { type: "json" };
import l1 from "./locales/ca.json" with { type: "json" };
import l2 from "./locales/cs.json" with { type: "json" };
import l3 from "./locales/da.json" with { type: "json" };
import l4 from "./locales/de.json" with { type: "json" };
import l5 from "./locales/el.json" with { type: "json" };
import l6 from "./locales/en.json" with { type: "json" };
import l7 from "./locales/es.json" with { type: "json" };
import l8 from "./locales/et.json" with { type: "json" };
import l9 from "./locales/fi.json" with { type: "json" };
import l10 from "./locales/fr.json" with { type: "json" };
import l11 from "./locales/hr.json" with { type: "json" };
import l12 from "./locales/hu.json" with { type: "json" };
import l13 from "./locales/is.json" with { type: "json" };
import l14 from "./locales/it.json" with { type: "json" };
import l15 from "./locales/lt.json" with { type: "json" };
import l16 from "./locales/nl.json" with { type: "json" };
import l17 from "./locales/no.json" with { type: "json" };
import l18 from "./locales/pl.json" with { type: "json" };
import l19 from "./locales/pt-br.json" with { type: "json" };
import l20 from "./locales/pt.json" with { type: "json" };
import l21 from "./locales/ro.json" with { type: "json" };
import l22 from "./locales/sl.json" with { type: "json" };
import l23 from "./locales/sr.json" with { type: "json" };
import l24 from "./locales/sv.json" with { type: "json" };
import l25 from "./locales/tr.json" with { type: "json" };
export const catalogs = {
  bg: l0,
  ca: l1,
  cs: l2,
  da: l3,
  de: l4,
  el: l5,
  en: l6,
  es: l7,
  et: l8,
  fi: l9,
  fr: l10,
  hr: l11,
  hu: l12,
  is: l13,
  it: l14,
  lt: l15,
  nl: l16,
  no: l17,
  pl: l18,
  "pt-br": l19,
  pt: l20,
  ro: l21,
  sl: l22,
  sr: l23,
  sv: l24,
  tr: l25,
};
